export default __webpack_public_path__ + "c92dd64.png";